<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--top">
            <header class="l-header l-header--top">
                <public-page-header />
            </header>

            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <header class="article-header">
                                                            <h1>会社概要</h1>
                                                            <div class="eyecatch-img">
                                                                <span></span>
                                                            </div>
                                                        </header>
                                                        <div class="company-page">
                                                            <section class="article-content">
                                                                <h4>hubsynch株式会社(hubsynch Inc.)</h4>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>本社所在地</td>
                                                                            <td>東京都港区白金台三丁目2番10号白金台ビル4B</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>設立</td>
                                                                            <td>2017年7月</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>資本金</td>
                                                                            <td>100万円</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>代表取締役</td>
                                                                            <td>沖津 貴俊</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>主要取引銀行</td>
                                                                            <td>三井住友銀行 恵比寿支店</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </section>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>

</template>
<script setup>
import { onMounted } from "vue";
import { initializeTop } from "@/assets/js/entries/top.js";
import PublicPageHeader from "@/components/PublicPageHeader.vue";

onMounted(() => {
    initializeTop();
})
</script>